import { render } from "./StandardButton.vue?vue&type=template&id=02ca4e0f&scoped=true&ts=true"
import script from "./StandardButton.vue?vue&type=script&lang=ts"
export * from "./StandardButton.vue?vue&type=script&lang=ts"

import "./StandardButton.vue?vue&type=style&index=0&id=02ca4e0f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02ca4e0f"]])

export default __exports__